require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-bala-c-deshpande.json") })
        }
      }, "path---insights-bala-c-deshpande");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-bala-c-deshpande!./.cache/json/insights-bala-c-deshpande.json
// module id = 1095
// module chunks = 231608221292675